import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register, formatApiErrorDetail } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      nav("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-6 py-16">
      <div className="w-full max-w-md fade-up">
        <div className="flex flex-col items-center gap-2 mb-8">
          <img src="/logo_mark.png" alt="Mulan Peptide Collection" className="h-16 w-16 object-contain" />
          <span className="font-head font-semibold text-xl tracking-[0.15em] text-primary">MULAN PEPTIDE</span>
        </div>
        <div className="bg-surface border border-black/10 p-8">
          <h1 className="font-head text-2xl mb-1">Create Account</h1>
          <p className="text-muted-foreground text-sm mb-8">Track orders and reorder faster.</p>
          {error && <p data-testid="register-error" className="text-destructive text-sm mb-4 border border-destructive/30 bg-destructive/10 p-3">{error}</p>}
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="label-mono text-muted-foreground block mb-2">Full Name</label>
              <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)}
                className="w-full bg-transparent border border-black/15 px-4 py-3 text-sm focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors" style={{ transition: "border-color 0.2s" }} />
            </div>
            <div>
              <label className="label-mono text-muted-foreground block mb-2">Email</label>
              <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border border-black/15 px-4 py-3 text-sm focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors" style={{ transition: "border-color 0.2s" }} />
            </div>
            <div>
              <label className="label-mono text-muted-foreground block mb-2">Password</label>
              <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border border-black/15 px-4 py-3 text-sm focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors" style={{ transition: "border-color 0.2s" }} />
            </div>
            <button data-testid="register-submit" disabled={loading} className="w-full bg-primary text-black label-mono py-4 hover:bg-[#E6C766] transition-colors disabled:opacity-50" style={{ transition: "background-color 0.2s" }}>
              {loading ? "Creating…" : "Create Account"}
            </button>
          </form>
          <p className="text-muted-foreground text-sm mt-6 text-center">
            Already registered? <Link to="/login" data-testid="go-login" className="text-primary hover:underline">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
